import "./ComingSoon.css";

export default function LandingPage() {
  return (
    <div className="coming-soon-page" data-testid="landing-page">
      <header className="wrap">
        <div className="brand"><span className="wordmark">teamie.</span></div>
        <p className="status">IN THE WORKS</p>
      </header>
      <main className="wrap" aria-label="Teamie coming soon">
        <div className="character">
          <svg className="mascot" viewBox="0 0 200 145" role="img" aria-label="Teamie smiling" fill="none" stroke="#111" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round">
            <g className="mascot-eyes"><path d="M42 54 Q58 31 74 54 M126 54 Q142 31 158 54" /></g>
            <path d="M62 91 Q100 124 138 91" />
          </svg>
          <p className="coming"><span aria-hidden="true" />Coming soon</p>
        </div>
      </main>
      <footer className="wrap" style={{ justifyContent: "flex-end" }}><span>© {new Date().getFullYear()} Teamie</span></footer>
    </div>
  );
}
